import { Exception } from 'app/api/exception/Exception';

/**
 * Исключение используется в случае когда запрашиваемые данные не найдены.
 */
export class NotFoundException extends Exception {
    static readonly NAME = 'NotFoundException';

    private static readonly NETWORK_ERROR_MESSAGE =
        'Не удалось выполнить операцию. Попробуйте ещё раз позже';

    constructor() {
        super(
            NotFoundException.NAME,
            NotFoundException.NAME,
            NotFoundException.NETWORK_ERROR_MESSAGE,
        );

        this.name = NotFoundException.NAME;
    }
}
